<div class="booble-backdrop">
  <div class="xp-modal xp-modal-cadastro">
    <div class="modal-dialog modal-xl modal-dialog-centered modal--xl modal--lg modal--md modal--sm">
      <div class="modal-content">
        <div class="modal-header">
          <div class="col-md-12">
            <div class="header-title">Conciliação financeira</div>
            <p class="header-subtitle">
              Informe as informações para realizar a conciliação
            </p>
          </div>
          <button type="button" class="btn-close" (click)="closeModal()" data-dismiss="modal"
            aria-label="Close"></button>
        </div>
        <div class="modal-body">

          <div class="modal-dialog-scrollable-general">
<!-- 
            <mat-accordion>
              <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    <h5>
                      Informações da ordem</h5>
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="detail-order">
                  <div class="content-detail-order">
                    <div class="container-display">
                      <p title="{{ boobleModalData.id }}" class="text-value">
                        <strong class="text-name">Número: </strong>{{ boobleModalData.id }}
                      </p>
                      <p title="{{
                        boobleModalData.amount | currency: boobleModalData.currency.description
                        }}" class="text-value">
                        <strong class="text-name">Valor de origem: </strong>{{
                        boobleModalData.amount | currency: boobleModalData.currency.description
                        }}
                      </p>
                      <p title="{{ boobleModalData.finality.description }}" class="text-value">
                        <strong class="text-name">Finalidade: </strong>{{ boobleModalData.finality.description }}
                      </p>
                      <span class="text-value">
                        <strong class="text-name">Status: </strong>

                        <span title="Pendente documentação" *ngIf="
                            boobleModalData.statusFlow == 'PENDING_DOCUMENTATION'
                          ">Pendente documentação</span>
                        <span class="red"
                          *ngIf='boobleModalData.statusFlow == "REPROVED_WITH_CORRECTION" || boobleModalData.statusFlow == "REPROVED_WITHOUT_CORRECTION"'>
                          Reprovada</span>

                        <span title="Invoice pendente" *ngIf="
                            boobleModalData.statusFlow == 'PENDING_INVOICE_ATTACHMENT'
                          ">Invoice pendente</span>

                        <span title="Liquidada" *ngIf="
                        boobleModalData.statusFlow == 'PAID'">Liquidada</span>

                        <span title="Disponível para cotação" class="green" *ngIf="
                            boobleModalData.statusFlow == 'AVAILABLE_QUOTATION'
                          ">Disponível para cotação</span>

                        <span title="Cotada" class="green" *ngIf="
                            boobleModalData.statusFlow == 'AVAILABLE_PAYMENT'
                          ">Cotada</span>

                        <span title="Em processamento" *ngIf="boobleModalData.statusFlow == 'PROCESSING'">Em
                          processamento</span>
                        <span title="Invoice pendente" *ngIf="
                            boobleModalData.statusFlow ==
                            'PENDING_INVOICE_INFORMATION'
                          ">Invoice pendente</span>
                      </span>
                    </div>

                    <div class="container-display">
                      <p class="text-value">
                        <strong class="text-name">Data de criação: </strong>{{ boobleModalData.createdDate | date:
                        "dd/MM/yyyy"
                        }}
                      </p>
                      <p>
                        <span class="text-value">
                          <strong class="text-name">Moeda de origem: </strong>

                          <span title="Dólar (USD)" *ngIf='boobleModalData.currency.description == "USD"'>Dólar
                            (USD)</span>
                          <span title="Euro (EUR)" *ngIf='boobleModalData.currency.description == "EUR"'>Euro
                            (EUR)</span>
                          <span title="Libra esterlina (GBP)"
                            *ngIf='boobleModalData.currency.description == "GBP"'>Libra esterlina
                            (GBP)</span>
                          <span title="Dólar canadense (CAD)"
                            *ngIf='boobleModalData.currency.description == "CAD"'>Dólar canadense
                            (CAD)</span>
                          <span title="Franco suíço (CHF)" *ngIf='boobleModalData.currency.description == "CHF"'>Franco
                            suíço
                            (CHF)</span>

                        </span>
                      </p>
                      <p class="text-value">
                        <strong class="text-name">Tipo de ordem: </strong><span title="Recebimento (inbound)"
                          *ngIf="boobleModalData.remmitanceType == 'INBOUND'">
                          Recebimento (inbound)</span>
                        <span title="Envio (outbound)" *ngIf="boobleModalData.remmitanceType == 'OUTBOUND'">
                          Envio (outbound)</span>
                      </p>
                    </div>
                  </div>
                  <br />

                  <h5 style="margin-bottom: 35px">Dados do cliente</h5>

                  <div class="content-detail-order">
                    <div class="container-display">
                      <p title="{{ boobleModalData.corporateAccount.companyName }}" class="text-value">
                        <strong class="text-name">Nome: </strong>{{ boobleModalData.corporateAccount.companyName }}
                      </p>
                      <p title="{{ boobleModalData.corporateAccount.cnpj }}" class="text-value">
                        <strong class="text-name">CNPJ: </strong>{{
                        boobleModalData.corporateAccount.cnpj
                        | mask: "AA.AAA.AAA/AAAA-00"
                        }}
                      </p>

                    </div>

                    <div class="container-display">
                      <p title="{{ boobleModalData.corporateAccount.cnpj }}" class="text-value">
                        <strong class="text-name">Matriz/Filial: </strong>{{
                        boobleModalData.corporateAccount.cnpj
                        | mask: "AA.AAA.AAA/AAAA-00"
                        }}
                      </p>
                      <ng-container *ngIf="boobleModalData.remmitanceType == 'INBOUND'">
                        <p title="{{ boobleModalData.sender.email }}" class="text-value">
                          <strong class="text-name">E-mail: </strong><span>
                            {{ boobleModalData.sender.email }}</span>
                        </p>
                      </ng-container>
                    </div>
                  </div>
                  <br />

                  <h5 style="margin-bottom: 35px">Dados do pagador</h5>

                  <ng-container *ngIf="boobleModalData.remmitanceType == 'INBOUND'">
                    <div class="content-detail-order">
                      <div class="container-display">
                        <p title="{{ boobleModalData.sender.companyName }}" class="text-value">
                          <strong class="text-name">Nome: </strong>{{ boobleModalData.sender.companyName }}
                        </p>
                      </div>

                      <div class="container-display">
                        <p title="{{ boobleModalData.sender.country }}" class="text-value">
                          <strong class="text-name">País: </strong>{{ boobleModalData.sender.country }}
                        </p>
                      </div>
                    </div>
                  </ng-container>

                  <ng-container *ngIf="boobleModalData.remmitanceType == 'OUTBOUND'">
                    <div class="content-detail-order">
                      <div class="container-display">
                        <p title="{{ boobleModalData.corporateAccount.companyName }}" class="text-value">
                          <strong class="text-name">Nome: </strong>{{ boobleModalData.corporateAccount.companyName }}
                        </p>
                        <p title="{{ boobleModalData.receiver.country }}" class="text-value">
                          <strong class="text-name">País: </strong>{{ boobleModalData.receiver.country }}
                        </p>
                      </div>

                      <div class="container-display">
                        <p title="{{ boobleModalData.corporateAccount.cnpj }}" class="text-value">
                          <strong class="text-name">CPF/CNPJ: </strong>{{
                          boobleModalData.corporateAccount.cnpj| mask: "AA.AAA.AAA/AAAA-00"
                          }}
                        </p>
                      </div>
                    </div>
                  </ng-container>

                </div>
              </mat-expansion-panel>
            </mat-accordion>


            <h5 style="margin-bottom: 20px; margin-top: 20px;">
              Informações do pagamento</h5>

            <div class="detail-payment">
              <div class="content-detail-order">
                <div class="container-display">
                  <p title="TED" class="text-value">
                    <strong class="text-name">Forma de pagamento: </strong>TED
                  </p>
                  <p class="text-value">
                    <strong class="text-name">Tipo de ordem: </strong><span title="Recebimento (inbound)"
                      *ngIf="boobleModalData.remmitanceType == 'INBOUND'">
                      Recebimento (inbound)</span>
                    <span title="Envio (outbound)" *ngIf="boobleModalData.remmitanceType == 'OUTBOUND'">
                      Envio (outbound)</span>
                  </p>
                </div>
                <div class="container-display">
                  <p title="{{
                    boobleModalData.amount | currency: boobleModalData.currency.description
                    }}" class="text-value">
                    <strong class="text-name">Valor de origem: </strong>{{
                    boobleModalData.amount | currency: boobleModalData.currency.description
                    }}
                  </p>
                  <p *ngIf="boobleModalData.remmitanceType == 'OUTBOUND'" title="{{
                    boobleModalData.quotations[0].effectiveAmount | currency: 'BRL'
                    }}" class="text-value">
                    <strong class="text-name">Valor: </strong>{{
                    boobleModalData.quotations[0].effectiveAmount | currency: 'BRL'
                    }}
                  </p>

                </div>
              </div>
              <br />
            </div>

            <h5 style="margin-bottom: 15px; margin-top: 15px;">
              Dados da efetivação</h5>

            <ng-container *ngIf="boobleModalData.remmitanceType == 'INBOUND'">

              <form class="form-content" [formGroup]="financialFormInbound">
                <div class="form-row">
                  <div class="col-lg-6 col-md-6">
                    <div class="line">
                      <div class="field-name label">Banco<span class="text-danger"> *</span></div>
                      <input formControlName="bankName" type="text" class="form-control" required />
                      <span class="text-danger"
                        *ngIf="(financialFormInboundControl.bankName.touched) && financialFormInboundControl.bankName.errors?.required">
                        Banco obrigatório
                      </span>
                    </div>
                  </div>
                  <div class="col-lg-6 col-md-6">
                    <div class="line">
                      <div class="field-name label">Número de ordem do banco<span class="text-danger"> *</span></div>
                      <input formControlName="orderNumber" type="text" class="form-control" required />
                      <span class="text-danger"
                        *ngIf="(financialFormInboundControl.orderNumber.touched) && financialFormInboundControl.orderNumber.errors?.required">
                        Número de ordem do banco obrigatório
                      </span>
                    </div>
                  </div>
                  <div class="col-lg-6 col-md-6">
                    <div class="line">
                      <div class="field-name label">Data do pagamento no exterior<span class="text-danger"> *</span>
                      </div>
                      <input matInput [matDatepicker]="picker" formControlName="paymentDate" (click)="picker.open()"
                        type="text" class="form-control" required />
                      <mat-datepicker #picker></mat-datepicker>
                      <span class="text-danger"
                        *ngIf="(financialFormInboundControl.paymentDate.touched) && financialFormInboundControl.paymentDate.errors?.required">
                        Data do pagamento no exterior obrigatória
                      </span>
                    </div>
                  </div>
                  <div class="col-lg-6 col-md-6">
                    <div class="line">
                      <div class="field-name label">Valor recebido<span class="text-danger"> *</span></div>
                      <input formControlName="amountReceived" currencyMask
                        [options]="{ prefix: '', thousands: '.', decimal: ',' }"
                        (blur)="financialFormInboundControl.amountReceived.value < 0 ? financialFormInboundControl.amountReceived.setValue(0) : financialFormInboundControl.amountReceived.value; financialFormInboundControl.amountReceived.value >= 999999 ? financialFormInboundControl.amountReceived.setValue(999999) : financialFormInboundControl.amountReceived.value;"
                        type="text" type="text" class="form-control" required />
                      <span class="text-danger"
                        *ngIf="(financialFormInboundControl.amountReceived.touched) && financialFormInboundControl.amountReceived.errors?.required">
                        Valor recebido obrigatório
                      </span>
                    </div>
                  </div>
                </div>
              </form>

            </ng-container>

            <ng-container *ngIf="boobleModalData.remmitanceType == 'OUTBOUND'">

              <form class="form-content" [formGroup]="financialFormOutbound">
                <div class="form-row">
                  <div class="col-lg-4 col-md-4">
                    <div class="line">
                      <div class="field-name label">Banco<span class="text-danger"> *</span></div>
                      <input formControlName="bankName" type="text" class="form-control" required />
                      <span class="text-danger"
                        *ngIf="(financialFormOutboundControl.bankName.touched) && financialFormOutboundControl.bankName.errors?.required">
                        Banco obrigatório
                      </span>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4">
                    <div class="line">
                      <div class="field-name label">Nº do boleto no Exchange<span class="text-danger"> *</span></div>
                      <input formControlName="billetNumber" type="text" class="form-control" required />
                      <span class="text-danger"
                        *ngIf="(financialFormOutboundControl.billetNumber.touched) && financialFormOutboundControl.billetNumber.errors?.required">
                        Nº do boleto no Exchange obrigatório
                      </span>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4">
                    <div class="line">
                      <div class="field-name label">Nº de ordem do banco<span class="text-danger"> *</span></div>
                      <input formControlName="orderNumber" type="text" class="form-control" required />
                      <span class="text-danger"
                        *ngIf="(financialFormOutboundControl.orderNumber.touched) && financialFormOutboundControl.orderNumber.errors?.required">
                        Número de ordem do banco obrigatório
                      </span>
                    </div>
                  </div>
                </div>
              </form>

            </ng-container> -->



          </div>

          <div class="dashboard-line-btn">
            <div class="form-row form-invoice">
              <div class="cols">
                <div class="form-group mb-0">
                  <button type="button" (click)="closeModal()" class="btn-xp-m2 btn-gray-new">
                    Voltar
                  </button>
                </div>
              </div>
              <div class="cols">
                <div class="form-group mb-0">
                  <button *ngIf="boobleModalData.remmitanceType == 'INBOUND'"
                    [ngClass]="{'btn-gray-disabled': financialFormInbound.invalid , 'btn-blue-30': !financialFormInbound.invalid}"
                    [disabled]="financialFormInbound.invalid" (click)="sendForm()" type="button"
                    class="btn-xp-m2 btn-blue-30">
                    Conciliar
                    <span class="spinner-border spinner-border-sm" *ngIf="loading"></span>
                  </button>
                  <button *ngIf="boobleModalData.remmitanceType == 'OUTBOUND'"
                    [ngClass]="{'btn-gray-disabled': financialFormOutbound.invalid , 'btn-blue-30': !financialFormOutbound.invalid}"
                    [disabled]="financialFormOutbound.invalid" (click)="sendForm()" type="button"
                    class="btn-xp-m2 btn-blue-30">
                    Conciliar e liquidar
                    <span class="spinner-border spinner-border-sm" *ngIf="loading"></span>
                  </button>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>
